import { Navigate } from "react-router-dom";
import { ReactElement } from "react";
import { SUPABASE } from "@/lib/db";
import { useSession } from "@/hooks/useSession";

function getRedirectToFromQuery(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get("redirect_to");
}

function isAllowedRedirect(url: string) {
  return (
    url.startsWith("https://estimate.nestrr.net") ||
    url.startsWith("https://www.nestrr.net") ||
    url.startsWith("http://localhost:3000")
  );
}

function getSafeRedirectToFromQuery(): string | null {
  const raw = getRedirectToFromQuery();
  if (!raw) return null;
  return isAllowedRedirect(raw) ? raw : null;
}

export const RequireToken = ({ children }: { children: ReactElement }) => {
  const { session, loading } = useSession();

  if (loading) {
    return <></>;
  }

  if (!session) {
    const redirectTo = getSafeRedirectToFromQuery();
    const path = redirectTo
      ? `/login?redirect_to=${encodeURIComponent(redirectTo)}`
      : "/login";

    return <Navigate to={path} replace />;
  }

  return children;
};

export const Logout = () => {
  SUPABASE.auth.signOut().then(() => {});
  return <Navigate to="/login" replace />;
};

export const signInWithGoogle = async (redirectTo?: string) => {
  const safeRedirect =
    redirectTo && isAllowedRedirect(redirectTo)
      ? redirectTo
      : `${window.location.origin}/app`;
  await SUPABASE.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo: safeRedirect,
      queryParams: {
        access_type: "offline",
        prompt: "consent",
      },
    },
  });
};

export const signInWithMicrosoft = async (redirectTo?: string) => {
  const safeRedirect =
    redirectTo && isAllowedRedirect(redirectTo)
      ? redirectTo
      : `${window.location.origin}/app`;

  await SUPABASE.auth.signInWithOAuth({
    provider: "azure",
    options: {
      redirectTo: safeRedirect,
      scopes: "openid profile email offline_access",
    },
  });
};
